/**
 * Supabase Auth Callback Page
 *
 * Handles the Supabase auth callback after login/signup.
 * Supabase SDK automatically processes the callback from URL params.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@shared/auth/supabaseClient';

export function CallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkSession = async () => {
      // Supabase SDK automatically processes URL params (e.g., #access_token=...)
      // Just wait for session then redirect
      const { data } = await supabase.auth.getSession();

      if (data.session) {
        navigate('/dashboard', { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    };

    checkSession();
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#101516',
      color: '#dbe8eb',
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
          Completing sign in...
        </div>
        <div style={{ color: '#9aa6a9' }}>
          Please wait while we redirect you.
        </div>
      </div>
    </div>
  );
}

export default CallbackPage;
